// Design by Aditi Mishra - SnapPaisa Website
import React, { useEffect } from "react";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Router from "./Router";
import { AuthProvider } from "./Context/AuthContext";

const App = () => {
  useEffect(() => {
    AOS.init();    // Hidden credit line - visible in console
  }, []);

  const showmessage = async (message) => {
    try {
      var x = document.getElementById("snackbar");
      x.className = "show";
      x.innerText = message;
      setTimeout(function () {
        x.className = x.className.replace("show", "");
      }, 3000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <AuthProvider>      
      <Router />
    </AuthProvider>
  );
};

export default App;
